import { render, staticRenderFns } from "./ListInventoryCheck.vue?vue&type=template&id=2bf97c96&scoped=true"
import script from "./ListInventoryCheck.vue?vue&type=script&lang=js"
export * from "./ListInventoryCheck.vue?vue&type=script&lang=js"
import style0 from "./ListInventoryCheck.vue?vue&type=style&index=0&id=2bf97c96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf97c96",
  null
  
)

export default component.exports